module.exports = __webpack_public_path__ + "static/media/HeartBorder.92135513.svg";